export default function propertyPriceFormatter( currency ) {
  return new Intl.NumberFormat( 'de-CH', {
    style: 'currency',
    currency: currency || 'CHF',
    currencyDisplay: 'symbol',
    maximumFractionDigits: 0,
  } )
}
